export default "__VITE_ASSET__BqDynCQm__"